import QuickQuote from "./quickQuote"

export { Consumer, Provider, QuickQuoteContext } from "./quickQuote.context"
export { sortQuotesByPremium } from "./quickQuote.helpers"
export default QuickQuote
